document.addEventListener('DOMContentLoaded', () => {

    const navigation = document.querySelector( '.js-navigation' );
    const navigationToggle = document.querySelector( '.js-navigationToggle' );
    const closeNavigationToggle = document.querySelector('.js-navigationClose');
   
    navigationToggle.addEventListener( 'click', ( e ) => {
        document.querySelector('body').classList.toggle( '-menuOpen' );
        navigationToggle.classList.toggle( '-active' );
        navigation.classList.toggle( '-open' );
    });
    
    closeNavigationToggle.addEventListener('click', () => {
        closeNavigation();
    });

    function closeNavigation() {
        document.querySelector('body').classList.remove( '-menuOpen' );
        navigationToggle.classList.remove( '-active' );
        navigation.classList.remove( '-open' );
    }

});